import v from "voca";
export default {
    isMobileDevice() {
        //List of mobile browser User-Agent strings
        //We keep the regular expression simple for this time round
        // let isMobileByUA = new RegExp("i(pad|phone)|Android|IEMobile|Mobile", "gi");
        let isMobile = false;
        // As certain tablet might hav a resolution more than 1024,
        // we cap mobile to 1023. Consistent with css breakpoint
        if (window.innerWidth < 768) {
            isMobile = true;
        }
        return isMobile;
    },
    getParentQueryString() {
        const parentUrl = window.location != window.parent.location
            ? document.referrer
            : document.location.href;
        const urlSearch = parentUrl.substring(parentUrl.indexOf("?") + 1);
        return urlSearch;
    },
    capitalize(str) {
        return v
            .chain(str)
            .lowerCase()
            .titleCase();
    },
    kebabCase(str) {
        return v.kebabCase(str);
    },
    camelCase(str) {
        return v.camelCase(str);
    },
    inIframe() {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            return false;
        }
    },
    isIE() {
        //@ts-ignore
        return window.document["documentMode"] !== undefined;
    }
};
